module.exports = __webpack_public_path__ + "static/img/U- head 60cm hollow DSK.18b4de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/U- head 60cm hollow DSK.jpg
// module id = 110
// module chunks = 1